import { FC, useMemo, useRef } from 'react';
import IconFont from '../../IconFont';
import { markTypeEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { isArray } from '@lhb/func';
import SiteMapExplainExtra, { ParagraphProps } from '@/common/components/business/SiteMap/SiteMapExplainExtra';
import { fullEditorCss } from '../../config-v2';

/**
 * @Description 评分介绍icon
 */
const ScoreExplaimIcon:FC<{
  data: any; // 商圈数据
  predictSale: any; // 是否展示预测营业额
  className?: any;
  showScoreDescriptionFlag?: any;
  scoreDescription?: any;
}> = ({
  data,
  predictSale,
  className,
  showScoreDescriptionFlag,
  scoreDescription,
}) => {
  const shadowRef: any = useRef();
  /**
   * @description 获取评分描述
   * @param data
   * @returns
   */
  const getExtraParagraph = () => {
    const { markType, scores } = data || {};
    if (markTypeEnum.four !== markType) return null;
    if (!isArray(scores) || !scores.length) return null;

    const filtered = scores.filter(itm => !!itm.name && !!itm.msg);
    if (!filtered.length) return null;

    const parag: ParagraphProps = {
      title: '评分说明',
      descriptions: filtered.map(itm => `${itm.name}：${itm.msg}`)
    };
    return parag;
  };

  const extraParagraph = useMemo(() => {
    return getExtraParagraph();
  }, [data]);


  return (
    <IconFont
      iconHref='iconxq_ic_shuoming_normal'
      className={className}
      tooltipConfig={{
        placement: 'bottom',
        overlayInnerStyle: {
          width: '320px',
          padding: '16px',
          boxSizing: 'border-box',
          borderRadius: '4px',
          maxHeight: 'calc(50vh)',
          overflowY: 'auto',
        },
        color: '#fff',
        onOpenChange(open) {
          // left: 737px; top: 137px; transform-origin: 50% -4px;
          if (showScoreDescriptionFlag === 2 && scoreDescription && open) {
            setTimeout(() => {
              // 创建Shadow DOM根节点
              const shadowRoot = shadowRef.current.attachShadow({ mode: 'open' });
              const contentDiv = document.createElement('div');
              contentDiv.innerHTML = scoreDescription;
              // 创建样式
              const style = document.createElement('style');
              style.textContent = fullEditorCss;
              // 添加到Shadow DOM
              shadowRoot.appendChild(style);
              shadowRoot.appendChild(contentDiv);
            }, 1);
          }
        },
        title: showScoreDescriptionFlag === 2 ? (
          <div ref={shadowRef}></div>
        ) : <SiteMapExplainExtra
          markType={data?.markType}
          isPredictSale={predictSale}
          extraParagraphs={extraParagraph ? [extraParagraph] : []}
        />,
      }}/>
  );
};

export default ScoreExplaimIcon;
